import { required, shape } from '@totalsoft/pure-validations';

export const financialIndicatorValidator = shape({
  orderNo: required,
  code: required,
  name: required,
  attributeName: required,
  scale: required
});
